module.exports = __webpack_public_path__ + "img/icon-loader-voiter2.6d4e97fd.svg";